import React from 'react';
import {connect} from 'react-redux';
import {add, deepClone, sortBy} from 'lodash';
import { DateTime } from 'luxon';


// local imports
import api from '../../../store/api'
import AdminWrapper from "../../theme/wrappers/AdminWrapper";
import {toggleGlobalLoader, addErrorAlert, addLoadingAlert, removeLoadingAlert, addSuccessAlert} from "../../../store/calls/alertLoadingDispatch";
import validators from "../../../utils/forms/validators";
import formatters from '../../../utils/forms/formatters';


import Input from "../../theme/forms/Input";
import BaseForm from "../../theme/forms/BaseForm";
import PaginatedTable from "../../theme/tables/PaginatedTable";
import ConfirmModal from "../../theme/modals/ConfirmModal";
import FormModal from "../../theme/modals/FormModal";
import * as preconfiguredInputs from "../../../utils/forms/preconfiguredInputs";





class SubdomainScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            displayedData: [],
            dataPullLimit: 100,
            dataPullOffset: 0,

            // edit and delete
            editModalOpen: false,
            editModalReset: 0,
            deleteModalOpen: false,
            editingInstance: null,



            improvementCategories: [],

            categoryFilter: null,
            nameFilter: null,
        }


        this.baseAPIPath = '/funders/';


        this.createEditInputs =  [
            {
                type: 'text',
                subLabel: 'Must be a valid subdomain with no spaces or special chars (hyphens allowed]). Ex: "my-subdomain"',
                label: "Subdomain",
                dataKey: "subdomain",
            },
            {
                type: 'text',
                label: "Description",
                dataKey: "description",
            },
        ]
    }

    componentDidMount() {
        toggleGlobalLoader(true)
        this.getData()
    }

    toggleEditModal = () => {
        this.setState({editModalOpen: !this.state.editModalOpen})
    }


    pullSubdomainStatsData = (start_date, end_date) => {
        return api.get('/dashboard-subdomain-stats/', { start_date, end_date })
            .then(res => res.data)
            // .catch(err => addErrorAlert("Subdomain Stats Data Load Failed"))
    }
    
    pullSubdomainList = (params) => {
        return api.get('/subdomain-configs/', {...params})
            .then(res => res.data)
            // .catch(res => res.data)
    }
    

    getData = () => {

        toggleGlobalLoader(true);

        let start_date = DateTime.local().minus({days: 90}).toISODate();
        let end_date = DateTime.local().toISODate();

        return Promise.all([
            this.pullSubdomainList({nameFilter: this.state.nameFilter}),
            this.pullSubdomainStatsData(start_date, end_date)
        ])
            .then(res => {
                let [subdomainList, subdomainStats] = res;
                let displayedData = subdomainList
                .map(subdomain => ({
                    ...subdomain,
                    ...(subdomainStats.find(d => subdomain.subdomain === d.subdomain_name) 
                    || {})
                })).map(d => ({
                    ...d,
                    _html_subdomain: <a href={`https://${d.subdomain}.cleanfi.com`}>{d.subdomain}</a>,
                    sudomain: d.subdomain,
                    project_count: d.project_count || 0,
                    applications_fee_paid: d.applications_fee_paid || 0,
                    project_estimated_average_amount: formatters.USDCurrency.formatter(d.project_estimated_average_amount || 0)
                })).sort((a, b) => b.project_count - a.project_count)
                
                this.setState({displayedData})
            })
            .catch(err => {
                console.error(err)
                addErrorAlert("Subdomain Data Load Failed")
            })
            .finally(() => toggleGlobalLoader(false))
        
    }

    // handleLimitChange = (val) => {
    //     this.setState({dataPullLimit: val}, this.getData)
    // }

    // handleOffsetChange = (val) => {
    //     this.setState({dataPullOffset: val}, this.getData)
    // }

    populateInputsWithValues = () => {
        return this.createEditInputs.map(d => ({
            ...d,
            value: this.state.editingInstance ? this.state.editingInstance[d.dataKey] : null
        }))

    }


    handleCreateRequest = (data) => {
        toggleGlobalLoader(true)
         api.post('/create-subdomain/', data)
            .then((res) => {
                addSuccessAlert('Subdomain Created');
                this.getData();
            })
            .catch(err => {
                console.error(err)
                addErrorAlert('Failed to create subdomain.');
            })
            .finally(() => {
                this.getData();
                toggleGlobalLoader(false);
                this.setState({editModalOpen: false, editingInstance: null})
            })
    }

    handleDeleteRequest = () => {
        toggleGlobalLoader(true)
        return api.delete(`/deactivate-subdomain/${this.state.editingInstance.subdomain}/`)
            .then(() => addSuccessAlert('Subdomain Deactivated'))
            .catch(err => {
                console.error(err)
                addErrorAlert('Failed to deactivate subdomain.');
            })
            .finally(() => {
                toggleGlobalLoader(false);
                this.setState({deleteModalOpen: false, editingInstance: null})
            })
    }


    handleSearch = (val) => {
        this.setState({nameFilter: val},
            this.getData
        )
    }


    render() {
        return (
            <AdminWrapper>
                <div className="section">
                    <div className="container is-fullhd mx-6">
                        <div className="level">
                            <div className="level-left">
                                <div className="level-item">
                                    <div>
                                        <h2 className="title is-2">Subdomains</h2>
                                        <p className="subtitle is-5 mt-4">Manage and create subdomains. Statistics are based on last 90 days.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="level-right">
                                <div className="level-item">
                                    {this.props.tokenData.admin && <button
                                        className='button is-link'
                                        onClick={() => this.setState({editModalOpen: true})}
                                    >+ Create New Subdomain</button>}
                                </div>
                            </div>
                        </div>
                        <PaginatedTable
                            className="is-fullwidth is-hoverable"
                            showPageNavigators={false}
                            data={this.state.displayedData}
                            columns={['subdomain', 'description', 'project_count', 'applications_fee_paid', 'project_estimated_average_amount']}
                            handleSearch={this.handleSearch}
                            actions={[{
                                name: 'Delete',
                                elem: (<span className="icon has-text-danger">
                                            <i className="fas fa-minus-square"/>
                                        </span>),
                                action: (data) => {
                                    this.setState({deleteModalOpen: true, editingInstance: {...data}})
                            }}]}
                        />
                    </div>
                </div>

                {this.state.editModalOpen && <FormModal
                    title="Create a new subdomain"
                    visible
                    inputs={this.populateInputsWithValues()}
                    disableAutocomplete
                    onSubmit={this.handleCreateRequest}
                    onCancel={() => this.setState({editModalOpen: false, editingInstance: null})}
                />}
                {this.state.deleteModalOpen && <ConfirmModal
                    type='danger'
                    visible
                    prompt={`Are you sure you want to delete ${this.state.editingInstance?.subdomain}?`}
                    onAccept={this.handleDeleteRequest}
                    onCancel={() => this.setState({deleteModalOpen: false, editingInstance: null})}
                 />}

            </AdminWrapper>
        )
    }

}


const mapStateToProps = state => ({
    tokenData: state.user.decodedTokenData
})



export default connect(mapStateToProps)(SubdomainScreen)
